import { Component } from '@angular/core';

@Component({
  selector: 'un-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {}
